import { render, staticRenderFns } from "./StatusBreakdown.vue?vue&type=template&id=5feb1b7c&scoped=true&"
import script from "./StatusBreakdown.vue?vue&type=script&lang=js&"
export * from "./StatusBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./StatusBreakdown.vue?vue&type=style&index=0&id=5feb1b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5feb1b7c",
  null
  
)

export default component.exports